exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-bar {\n  background: #363636;\n  color: white;\n  width: 100%;\n  overflow: hidden;\n  padding: .5em .5em .2em 1em;\n  font-size: .9em; }\n  .top-bar h1 {\n    margin: 0;\n    padding: 0;\n    display: inline-block; }\n  .top-bar .logout-link {\n    display: inline-block;\n    float: right;\n    padding: .7em;\n    cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/container/views/TopBarComponent/topBar.component.scss
// module id = ./src/app/modules/container/views/TopBarComponent/topBar.component.scss
// module chunks = main